module.exports = __webpack_public_path__ + "img/cloak.dbab02d0.svg";